<template lang="pug">
  b-modal#approveAffiliate(
    ref="approveAffiliate"
    :title="$t('ui.combine.approve_affiliate')"
    centered
    no-fade
    no-close-on-backdrop
    :busy="loading"
    @ok="done"
    @show="reset"
    @shown="shown"
  )
    b-form(novalidate :disabled="!feedback.success" @submit.stop.prevent="submit")
      b-form-group(:label="$t('ui.account_id')" disabled).mb-0
        DebounceInput(
          size="sm"
          ref="account_id"
          required
          type="text"
          :dirty="$v.account_id.$dirty"
          :error="$v.account_id.$error"
          v-model.trim.lazy="$v.account_id.$model"
          :disabled="loading"
          :maxLength="$v.account_id.$params.maxLength.max"
        )
        ValidateResult(:value="$v.account_id" :name="$t('ui.account_id')")
      b-form-group(:label="$t('ui.settlement_type')").mb-0
        SettlementTypeLookupAff(
          ref="settlement_type"
          size="sm"
          required
          type="array"
          :dirty="$v.settlement_type.$dirty"
          :error="$v.settlement_type.$error"
          v-model.trim.lazy="$v.settlement_type.$model"
          :disabled="loading"
        )
        ValidateResult(:value="$v.settlement_type" :name="$t('ui.settlement_type')")
      b-form-group(:label="$t('ui.carry_over')").mb-2
        div.d-flex
          label.custom-switch
            input.custom-switch-input(
              type="checkbox"
              required
              :dirty="$v.carry_over.$dirty"
              :error="$v.carry_over.$error"
              v-model.trim.lazy="$v.carry_over.$model"
              :disabled="loading"
            )
            span.custom-switch-indicator
      b-form-group(:label="$t('ui.comm_sports')").mb-0
        b-form-select(
          size="sm"
          :dirty="$v.comm_sports.$dirty"
          :error="$v.comm_sports.$error"
          v-model.trim.lazy="$v.comm_sports.$model"
        )
          option(v-for="opt in commSportsOpt" :value="opt.value") {{ opt.text }}
        ValidateResult(:value="$v.comm_sports" :name="$t('ui.comm_sports')")
      b-form-group(:label="$t('ui.comm_slots')").mb-0
        b-form-select(
          size="sm"
          :dirty="$v.comm_slots.$dirty"
          :error="$v.comm_slots.$error"
          v-model.trim.lazy="$v.comm_slots.$model"
        )
          option(v-for="opt in commSlotsOpt" :value="opt.value") {{ opt.text }}
        ValidateResult(:value="$v.comm_slots" :name="$t('ui.comm_slots')")
      b-form-group(:label="$t('ui.comm_livecasino')").mb-0
        b-form-select(
          size="sm"
          :dirty="$v.comm_livecasino.$dirty"
          :error="$v.comm_livecasino.$error"
          v-model.trim.lazy="$v.comm_livecasino.$model"
        )
          option(v-for="opt in commLivecasinoOpt" :value="opt.value") {{ opt.text }}
        ValidateResult(:value="$v.comm_livecasino" :name="$t('ui.comm_livecasino')")
      b-form-group(:label="$t('ui.comm_cockfight')").mb-0
        b-form-select(
          size="sm"
          :dirty="$v.comm_cockfight.$dirty"
          :error="$v.comm_cockfight.$error"
          v-model.trim.lazy="$v.comm_cockfight.$model"
        )
          option(v-for="opt in commCockfightOpt" :value="opt.value") {{ opt.text }}
        ValidateResult(:value="$v.comm_cockfight" :name="$t('ui.comm_cockfight')")
      b-form-group(:label="$t('ui.comm_others')").mb-0
        b-form-select(
          size="sm"
          :dirty="$v.comm_others.$dirty"
          :error="$v.comm_others.$error"
          v-model.trim.lazy="$v.comm_others.$model"
        )
          option(v-for="opt in commOthersOpt" :value="opt.value") {{ opt.text }}
        ValidateResult(:value="$v.comm_others" :name="$t('ui.comm_others')")
      //- div.row
      //-   div.col
      //-     b-alert.animated.flash(:show="!feedback.success" variant="bottom") {{ $t("error." + feedback.status) }}
    div(slot="modal-cancel")
      SubmitButton(:loading="loading" icon="fa fa-ban" :text="$t('ui.cancel')" isModal=true)
    div(slot="modal-ok")
      SubmitButton(:loading="loading" icon="fa fa-save" :text="$t('ui.save')" isModal=true)
  </template>
  
  <script>
  import { required, alphaNum, minLength, maxLength, integer, numeric, helpers, decimal } from "vuelidate/lib/validators";
  import config from "@/config";
  import errorTags from "@/errorTags";
  import SubmitButton from "@/library/SubmitButton";
  import ValidateResult from "@/library/ValidateResult";
  import DebounceInput from "@/library/DebounceInput";
  import SettlementTypeLookupAff from "@/library/SettlementTypeLookupAff";
  const alphaNumWithSpace = helpers.regex("alphaNumWithSpace", /^[a-z\d\-_\s]+$/i);
  
  export default {
    components: {
      SubmitButton,
      ValidateResult,
      DebounceInput,
      SettlementTypeLookupAff,
    },
    props: {
      item: {
        type: Object
      }
    },
    data() {
      return {
        operator_id: "",
        account_id: "",
        contact_phone: "",
        settlement_type: "",
        carry_over: false,
        comm_sports: 0,
        comm_slots: 0,
        comm_livecasino: 0,
        comm_cockfight: 0,
        comm_others: 0,
        loading: false,
        feedback: {
          success: true,
          status: ""
        },
        commOpt: [],
        uplineCommList: [],
      };
    },
    computed: {
      commSportsOpt() {
        // return this.commOpt.filter(d => { return d.value <= parseFloat(this.uplineCommList[0]['sports']) });
        return this.commOpt;
      },
      commSlotsOpt() {
        // return this.commOpt.filter(d => { return d.value <= parseFloat(this.uplineCommList[0]['slots']) });
        return this.commOpt;
      },
      commLivecasinoOpt() {
        // return this.commOpt.filter(d => { return d.value <= parseFloat(this.uplineCommList[0]['livecasino']) });
        return this.commOpt;
      },
      commCockfightOpt() {
        // return this.commOpt.filter(d => { return d.value <= parseFloat(this.uplineCommList[0]['cockfight']) });
        return this.commOpt;
      },
      commOthersOpt() {
        // return this.commOpt.filter(d => { return d.value <= parseFloat(this.uplineCommList[0]['others']) });
        return this.commOpt;
      },
    },
    validations: {
      account_id: {
        required,
        minLength: minLength(4),
        maxLength: maxLength(20)
      },
      settlement_type: {
        required
      },
      carry_over: {
        required
      },
      comm_sports: {
        required
      },
      comm_slots: {
        required
      },
      comm_livecasino: {
        required
      },
      comm_cockfight: {
        required
      },
      comm_others: {
        required
      },
    },
    methods: {
      done: function(evt) {
        evt.preventDefault();
        this.submit();
      },
      getCommLookup: function() {
        for (var i = 0; i <= 100; i+= 1) {
          this.commOpt.push({value: i, text: i + '%'});
        }
      },
      getUplineComm: function() {
        let url = config.commissionGetAffUrl();
  
        var json = {
          action_by: this.$store.getters.loginId,
          auth_token: this.$store.getters.sessionToken,
          account_id: this.$store.getters.accountId,
          operator_id: this.operator_id
        };
  
        this.loading = true;
        this.$http.post(url, json).then(
          function(response) {
            this.loading = false;
            // Success
            try {
              if (response) {
                this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;
  
                this.feedback.status = response.data.statusdesc;
                if (this.feedback.success == true) {
                  this.uplineCommList = response.data.dt;
                } else {
                  if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
                }
              }
            } catch (error) {
              this.feedback.success = false;
              this.feedback.status = errorTags.request.failed;
              this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
            }
          },
          function(response) {
            this.loading = false;
            // Error
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
          }
        );
      },
      submit: function() {
        this.$v.$touch();
        if (!this.$v.$invalid) {
          let url = config.accountApproveAffUrl();
  
          var json = {
            action_by: this.$store.getters.loginId,
            auth_token: this.$store.getters.sessionToken,
            account_id: this.account_id,
            operator_id: this.operator_id,
            settlement_type: this.settlement_type,
            carry_over: this.carry_over,
            comm_sports: this.comm_sports,
            comm_slots: this.comm_slots,
            comm_livecasino: this.comm_livecasino,
            comm_cockfight: this.comm_cockfight,
            comm_others: this.comm_others,
            contact_phone: this.contact_phone,
            audit_by: this.$store.getters.loginId
          };
  
          this.feedback.success = true;
          this.loading = true;
          this.$http.post(url, json).then(
            function(response) {
              this.loading = false;
              // Success
              try {
                if (response) {
                  if (typeof response.data.status == "string") {
                    this.feedback.success = response.data.status == "1";
                  } else {
                    this.feedback.success = response.data.status == 1;
                  }
                  this.feedback.status = response.data.statusdesc;
                  if (this.feedback.success == true) {
                    this.$emit("clicked");
                    this.$refs.approveAffiliate.hide();
                  } else {
                    this.$helpers.handleFeedback(this.feedback.status);
                    this.$emit("failed", "approve_affiliate", this.feedback.status);
                    this.$refs.approveAffiliate.hide();
                  }
                }
              } catch (error) {
                this.feedback.success = false;
                this.feedback.status = errorTags.request.failed;
              }
            },
            function(response) {
              this.loading = false;
              // Error
              this.feedback.success = false;
              this.feedback.status = errorTags.request.failed;
            }
          );
        }
      },
      reset: function() {
        this.feedback.success = true;
        this.feedback.status = "";
      },
      shown: function() {
        this.$v.$reset();
        this.getCommLookup();
        this.account_id = this.item.account_id;
        this.operator_id = this.item.operator_id;
        this.contact_phone = this.item.contact_phone;
        this.settlement_type = "";
        this.carry_over = false;
        this.comm_sports = 0;
        this.comm_slots = 0;
        this.comm_livecasino = 0;
        this.comm_cockfight = 0;
        this.comm_others = 0;
        this.getUplineComm();
        // this.$refs.comm_package.$el.focus();
      }
    }
  };
  </script>
  